import React from "react";

const ChildExpenseSummary = ({ payload, activeTabName }) => {
  const preBirthKeys = [
    "Amount Needed in Future with Inflation",
    "Home birth",
    "Birth center",
    "Vaginal birth with health insurance",
    "Vaginal birth without health insurance",
    "C-section birth with health insurance",
    "C-section birth without health insurance",
  ];

  const firstYearKeys = [
    "Crib and mattress",
    "Bassinet",
    "Changing table",
    "Blankets/Bedding",
    "Baby Monitor",
    "Rocking Chair/Glider",
    "Dresser",
    "Decorations and other misc.",
    "Diaper pail",
    "Bathtub",
    "Washcloths, Hooded Baby Towel, and other misc.",
    "Forehead Thermometer",
    "Humidifier/Purifier",
    "Car Seat",
    "Stroller",
    "Travel Crib",
    "Baby Carrier (ERGO, Boba, Moby, etc.)",
    "Family Photo Sessions",
    "Occasional baby sitter",
    "Daycare",
    "Home-Based daycare",
    "Custom",
    "Disposable diapers",
    "Disposable wipes",
    "Formula feeding (if needed)",
    "New clothes",
    "Second-hand clothes",
    "Health insurance",
    "Books",
    "Activities and classes",
    "Toys",
    "Additional",
  ];

  const getSum = (keys) =>
    keys.reduce((acc, key) => {
      const val = payload[key] && parseFloat(payload[key]);
      return acc + (!isNaN(val) ? val : 0);
    }, 0);

  const formatCurrency = (amount) => {
    const num = Number(amount) || 0; // Ensure it's always a number
    return "$" + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  
  const preBirthSum = Number(getSum(preBirthKeys)) || 0;
  const firstYearSum = Number(getSum(firstYearKeys)) || 0;

  const totalNeed = preBirthSum + firstYearSum;

  return (
    <div>
      {activeTabName &&
        [
          "ASSISTANCE FROM FRIENDS AND FAMILY",
          "ASSIGN ASSET",
          "ADD SAVINGS",
          "ADD LOAN",
          "BIRTH",
          "PREPARING FOR THE NEW ARRIVAL",
          "BATH AND HEALTH",
          "TRAVEL AND TRANSPORTATION",
          "COSTS THROUGHTOUT YEAR",
          "ADDITIONAL COSTS THROUGHTOUT YEAR",
          "BOOKS, TOYS, ACTIVITIES",
        ].includes(activeTabName) && (
          <div className="descriptionDisplay">
            <div>
              Pre-birth and Birth Expenses:{" "}
              {preBirthSum ? formatCurrency(preBirthSum) : "$0.00"}
            </div>
            <div>
              First Year Expenses:{" "}
              {firstYearSum ? formatCurrency(firstYearSum) : "$0.00"}
            </div>
            <div>
              <strong>
                Total Need: {totalNeed ? formatCurrency(totalNeed) : "$0.00"}
              </strong>
            </div>
          </div>
        )}
      {activeTabName &&
        ["GOAL DETAILS", "BIRTH", "PREPARING FOR THE NEW ARRIVAL"].includes(
          activeTabName
        ) && (
          <div className="descriptionDisplay-form">
            <strong>Pre-Birth</strong>
          </div>
        )}

      {activeTabName &&
        [
          "BATH AND HEALTH",
          "TRAVEL AND TRANSPORTATION",
          "COSTS THROUGHTOUT YEAR",
          "ADDITIONAL COSTS THROUGHTOUT YEAR",
          "BOOKS, TOYS, ACTIVITIES",
        ].includes(activeTabName) && (
          <div className="descriptionDisplay-form">
            <strong>First Year</strong>
          </div>
        )}
    </div>
  );
};

export default ChildExpenseSummary;
